import dayjs from "dayjs";

import { getCampaignMaxAvailableDate } from "app/pages/digital-marketing/keywords-campaigns/infra/KeywordsCampaignsContextUtils";
import type { DatesRange } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

export const isKeywordsReportLatestAvailableDay = (
    durationObject: DatesRange | undefined,
    lastScrapeDate: string | null,
): boolean => {
    if (!durationObject?.to) {
        return false;
    }
    const maxDay = dayjs(getCampaignMaxAvailableDate(lastScrapeDate)).format("YYYY-MM-DD");
    const rangeEndDay = durationObject.to.format("YYYY-MM-DD");
    return rangeEndDay === maxDay;
};
